"use strict";
/**
 * The single rule for "can this tenant operate", shared by platform-app,
 * pos-auth, pos-sales and ecommerce so the answer cannot differ per surface.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ACCESS_STATES = void 0;
exports.tenantAccessState = tenantAccessState;
exports.isSellBlocked = isSellBlocked;
exports.ACCESS_STATES = ['active', 'grace', 'suspended'];
/**
 * FAIL-SAFE BY DESIGN: anything unrecognised returns 'active'. A failed lookup
 * or an unknown status must never stop a paying tenant trading. Suspension is
 * only ever the result of an explicit, recognised signal.
 */
function tenantAccessState(t, now) {
    if (t.status === 'suspended')
        return 'suspended';
    if (t.status === 'grace') {
        if (typeof t.graceUntil === 'number' && t.graceUntil <= now)
            return 'suspended';
        return 'grace';
    }
    return 'active';
}
/** Selling is blocked only by suspension. Grace deliberately still sells. */
function isSellBlocked(state) {
    return state === 'suspended';
}
//# sourceMappingURL=tenantAccess.js.map